import React from 'react';
import {Row, ContenedorForm, HeaderForm, CuerpoForm, TituloForm, ContainerCol, ContenedorToggle } from '../componentes_generales/componentes_formulario/contenedores/';
import { LabelNota, LabelForm } from '../componentes_generales/componentes_formulario/labels/';
import styled from 'styled-components';
import global_axios  from '../../funciones_globales/interaccionapi';
import moment from 'moment';
import PickerFecha from '../componentes_generales/componentes_formulario/datepicker/datepicker';
import AgGridRender from '../componentes_generales/grid/ag_grid_render';
import InputSearch from '../componentes_generales/componentes_formulario/inputs/inputsearch';
import { cargar_PlanillaDepositoChequeDistrib, cargar_CtasBancariasPorDistribPlanillaDeposito, cargar_DetalleChequesPlanillaDeposito } from '../../actions/bancos/act_banc05';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm } from '../../actions/generales/act_gen03';
import { validarCampoString, validarFechaTransaccionSeleccionada, validarPermisoAcceso } from '../../funciones_globales/utils'
import { cambiar_VisualizacionLoading } from '../../actions/generales/act_gen01';
import { getItemDatosSesion, getFechaProcesoPorModulo } from '../../funciones_globales/manejosesion';
import { formatearFechaMoment_a_String } from '../../funciones_globales/format';
import ToggleSwitch from '@trendmicro/react-toggle-switch';
import '@trendmicro/react-toggle-switch/dist/react-toggle-switch.css';

const LabelCtaSeleccionada = styled.label`
    display: block;
    font-size: 11px;
    color: red;
`;

const LabelOperacion = styled.h3`
    display: inline-block;
    font-size: 12px;
    color: red;
    margin: 10px 0px 0px 0px;
    font-weight: 600;
`;

class FormBanco02 extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            planillaDepositoId: '',
            fechaDeposito: null,
            ctaDepositoSeleccionada: '',
            codCtaDepositoSeleccionada: '',
            chequesPorCuenta: [],
            cuentasBancarias: [],
            isDeposito: true,
            operacion: 'G',
            columnsDefGridChequesPorCuenta: [
                {   header: "No.",
                    field: "Nro",
                    width: 35,
                    type: "string",
                    suppressFilter: true
                },
                {   header: "F. Vcto. Cheque",
                    field: "FechaVctoCheque",
                    width: 90,
                    type: "string"
                },
                {   header: "Cliente",
                    field: "Cliente",
                    width: 245,
                    type: "string"
                },
                {   header: "Banco",
                    field: "Banco",
                    width: 160,
                    type: "string"
                },
                {   header: "Cuenta",
                    field: "Cuenta",
                    width: 100,
                    type: "string"
                },
                {   header: "No. Cheque",
                    field: "Cheque",
                    width: 75,
                    type: "string"
                },
                {   header: "Valor",
                    field: "Valor",
                    width: 85,
                    type: "num_decimal"
                },
                {   header: "No. Comprobante",
                    field: "Papeleta",
                    width: 115,
                    type: "string",
                    editable: true
                },
                {   header: "Mov. Banco",
                    field: "MovBanco",
                    width: 100,
                    type: "string"                    
                }
            ],
            columnsDefGridCuentas: [
                {   header: "No.",
                    field: "Nro",
                    width: 40,
                    type: "string"
                },
                {   header: "Cód. Cta.",
                    field: "CodCuenta",
                    width: 70,
                    type: "string"
                },
                {   header: "Cuenta Bancaria",
                    field: "Cuenta",
                    width: 247,
                    type: "string"
                },
                {   header: "No. Cheques",
                    field: "NroCheques",
                    width: 100,
                    type: "num_entero"
                },
                {   header: "Total",
                    field: "Total",
                    width: 100,
                    type: "num_decimal"
                },
                {   header: "Ch. Depositados",
                    field: "NroCheqDepositados",
                    width: 100,
                    type: "num_entero"
                }
            ]
        };

        this.gridChequesPorCuentaOptions = {
            enableColResize: true,
            enableSorting: true,
            enableFilter: true,
            singleClickEdit: true,
        };

        this.gridCuentasOptions = {
            enableColResize: true,
            rowSelection: 'single',            
            onRowDoubleClicked: ()=>{
                this.seleccionarChequesPorCuentaDeposito();
            }
        };

        this.cambiarValoresInput = this.cambiarValoresInput.bind(this);
        this.getPlanillaDepositobyId = this.getPlanillaDepositobyId.bind(this);
        this.limpiar = this.limpiar.bind(this);
        this.procesarDepositos = this.procesarDepositos.bind(this);
        this.onGridChequesPorCuentaReady = this.onGridChequesPorCuentaReady.bind(this);
        this.onGridCuentasReady = this.onGridCuentasReady.bind(this);
        this.cargarCuentasBancariasPorPlanillaDeposito = this.cargarCuentasBancariasPorPlanillaDeposito.bind(this);
        this.cargarChequesPlanillaDeposito = this.cargarChequesPlanillaDeposito.bind(this);
        this.anularLoteDepositos = this.anularLoteDepositos.bind(this);
    }

    onGridChequesPorCuentaReady(params){
        this.apiGridChequesPorCuenta = params.api;
        this.columnApiGridChequesPorCuenta = params.columnApi;
    }

    onGridCuentasReady(params){
        this.apiGridCuentas = params.api;
        this.columnApiGridCuentas = params.columnApi;
    }

    componentDidMount(){
        this.props.generar_LogAuditoriaIngresoForm('0702');
        let fechaProceso = getFechaProcesoPorModulo('07');
        this.setState({fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY')});
    }

    componentWillUnmount(){
        this.props.generar_LogAuditoriaSalidaForm('0702');
    }

    cambiarValoresInput(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        this.setState({
          [name]: value
        });
    }

    getPlanillaDepositobyId(){
        if (!validarCampoString(this.state.planillaDepositoId, 1, 7)){
            alert('No ha especificado correctamente el campo Planilla Depósito Cheque');
            return;
        }
      
        this.props.cargar_PlanillaDepositoChequeDistrib(this.state.planillaDepositoId)
        .then(()=>{
            if(this.props.planillaDepCheque===null){
                alert('No existe una Planilla Depósito Cheque con el código especificado que cuente con una distribución generada.');
                return;
            }
            this.cargarCuentasBancariasPorPlanillaDeposito();            
        });
    }

    limpiar(){
        let fechaProceso = getFechaProcesoPorModulo('07');        
        this.setState({
            operacion: 'G',
            planillaDepositoId: '',
            chequesPorCuenta: [],
            cuentasBancarias: [],
            ctaDepositoSeleccionada: '',
            codCtaDepositoSeleccionada: '',
            fechaDeposito: moment(fechaProceso, 'DD/MM/YYYY'),
            isDeposito: true
        });
    }

    cargarCuentasBancariasPorPlanillaDeposito(){
        this.props.cargar_CtasBancariasPorDistribPlanillaDeposito(this.state.planillaDepositoId)
        .then(()=>{
            let cuentasBancarias = [];
            this.props.cuentasBancarias.forEach((itemCuenta, i)=>{
                let nroCheqDepositados = itemCuenta.NroChequesDep!==null?itemCuenta.NroChequesDep:0;                
                cuentasBancarias.push({
                    Nro: (i+1),
                    CodCuenta: itemCuenta.CodigoCtaBancaria,
                    Cuenta: itemCuenta.cta.Nombre + ' - ' + itemCuenta.cta.Numero,
                    NroCheques: itemCuenta.NroCheques,
                    Total: itemCuenta.Total,
                    NroCheqDepositados: nroCheqDepositados,
                    CtaContable: itemCuenta.cta.ConCuenta
                });
            });
            this.setState({cuentasBancarias});
        });
    }

    cargarChequesPlanillaDeposito(planillaDepositoId, estadoChequesEnPlanilla, loteDepCheque){
        this.props.cargar_DetalleChequesPlanillaDeposito(planillaDepositoId, estadoChequesEnPlanilla, loteDepCheque)
        .then(()=>{
            let chequesPorCuentaDepositados = [];
            this.props.itemsPlanillaDepCheque.forEach((item) => {                
                this.state.chequesPorCuenta.forEach(chequePorCta =>{
                    if (item.Secuencial === chequePorCta.SecuencialCheque){
                        chequesPorCuentaDepositados.push({  ...chequePorCta,
                                                            Nro: chequesPorCuentaDepositados.length+1,
                                                            Status: item.Status,
                                                            MovBanco: item.MovBanco});
                    }
                })
            });
            this.setState({chequesPorCuenta: chequesPorCuentaDepositados});
        });
    }
    
    seleccionarChequesPorCuentaDeposito(){
        if (this.props.planillaDepCheque.detCheques === undefined){
            alert('No existe una Planilla Depósito Cheque seleccionada.');
            return;
        }

        if (this.props.planillaDepCheque.detCheques.length===0){
            alert('La Planilla Depósito Cheque seleccionada no tiene cheques distribuidos para depositar.');
            return;
        }

        let cuentaBancariaSel = this.apiGridCuentas.getSelectedRows()[0];
        
        if (!validarCampoString(cuentaBancariaSel.CtaContable, 1, 17)){
            alert('La Cuenta Bancaria seleccionada no tiene asignada una Cuenta Contable.');
            return;
        }

        if(this.state.operacion==='G'){
            if (!(cuentaBancariaSel.NroCheqDepositados<cuentaBancariaSel.NroCheques)){
                alert('La Cuenta Bancaria seleccionada no tiene Cheques pendientes de depositar.');
                return;
            }
        }else{
            if (cuentaBancariaSel.NroCheqDepositados===null || cuentaBancariaSel.NroCheqDepositados<=0){
                alert('La Cuenta Bancaria seleccionada no tiene Cheques depositados que se puedan anular.');
                return;
            }
        }    
        
        let codigoCtaBancaria = cuentaBancariaSel.CodCuenta;

        let chequesPorCuenta = [];
        this.props.planillaDepCheque.detCheques.forEach((item) => {
            let statusParaMostrar = this.state.operacion==='G'?'D':'E';

            if (item.CuentaBancoDep===codigoCtaBancaria && item.Status===statusParaMostrar){
                chequesPorCuenta.push({
                    Nro: chequesPorCuenta.length+1,
                    FechaVctoCheque: item.FechaVctoCheque,
                    Cliente: item.cli.Codigo + ' - ' + item.cli.Nombre,
                    Banco: item.bco.Codigo + ' - ' + item.bco.Descripcion,
                    Cuenta: item.Cuenta,
                    Cheque: item.Cheque,
                    Valor: item.Valor,
                    Papeleta: statusParaMostrar==='D'?'':(item.movBco==null?'':item.movBco.Referencia),
                    MovBanco: statusParaMostrar==='D'?'':item.MovBanco,
                    SecuencialCheque: item.Secuencial,
                    Status: item.Status
                });
            }
        });
        this.setState({chequesPorCuenta, ctaDepositoSeleccionada: cuentaBancariaSel.Cuenta, codCtaDepositoSeleccionada: codigoCtaBancaria});
    }

    procesarDepositos(){

        let planillaDepositoId = this.state.planillaDepositoId;

        if (!validarCampoString(planillaDepositoId,1, 10)){
            alert('El campo Planilla Depósito Cheque no ha sido especificado.');
            return;
        }

        if (this.state.chequesPorCuenta.length===0){
            alert('No existen Cheques que se puedan depositar.');
            return;
        }

        let nroItemsADepConPapeleta = 0;
        let nroItemsADepConStatus = 0;

        let chequesADepositar = [];
        this.state.chequesPorCuenta.forEach((cheque)=>{
            if(cheque.Status==='D'){
                nroItemsADepConStatus+=1;
                if (validarCampoString(cheque.Papeleta, 1, 30)){
                    nroItemsADepConPapeleta+=1;
                    chequesADepositar.push({SecChqEnPlanilla: cheque.SecuencialCheque,
                                            Papeleta: cheque.Papeleta});
                }
            }
        });

        if (nroItemsADepConStatus === 0){
            alert('No ha seleccionado los cheques que va proceder a depositar.');
            return;
        }

        if (nroItemsADepConPapeleta === 0){
            alert('No ha especificado en ningún Cheque el No. de Comprobante de Depósito.');
            return;
        }

        let fechaProceso = getFechaProcesoPorModulo('07');

        if (this.props.permiteCambioFProceso==='S'){
            let validFProceso = validarFechaTransaccionSeleccionada(this.state.fechaDeposito, moment(fechaProceso, 'DD/MM/YYYY'), this.props.diasPermiteCambioFProceso);
        
            if(!validFProceso.esValida){
                alert(validFProceso.msg);
                return;
            }
        }

        let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
        if (!validPermiso.esValido){
            alert(validPermiso.msg);
            return;
        }
        
        let confirmarProcDep = window.confirm(`¿Está seguro de procesar el Lote de Depósitos seleccionado con Fecha Depósito: ${formatearFechaMoment_a_String(this.state.fechaDeposito)}. Nro Cheques: ${nroItemsADepConPapeleta}?`);
        if(!confirmarProcDep){
          return;
        }        

        let loteDepCheques = {
            idPlanillaDepCheque: planillaDepositoId,
            fechaDeposito: formatearFechaMoment_a_String(this.state.fechaDeposito),
            Cheques: chequesADepositar,
            usuario: getItemDatosSesion('usuario'),
            moneda: JSON.parse(getItemDatosSesion('moneda')).Moneda,
            dolar: JSON.parse(getItemDatosSesion('moneda')).Cotizacion
        }

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'POST',
            url: '/depositoscheque',
            data: loteDepCheques
        })
        .then((response)=>{
            alert('Se procesó exitosamente el Lote de Depósitos.');
            let loteDepCheque = response.data.nroLote;
            this.props.cambiar_VisualizacionLoading(false);
            this.cargarCuentasBancariasPorPlanillaDeposito();
            this.cargarChequesPlanillaDeposito(planillaDepositoId, 'E', loteDepCheque);
            this.props.cargar_PlanillaDepositoChequeDistrib(this.state.planillaDepositoId);
        })
        .catch(error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    anularLoteDepositos(){
        let planillaDepositoId = this.state.planillaDepositoId;

        if (!validarCampoString(planillaDepositoId,1, 10)){
            alert('El campo Planilla Depósito Cheque no ha sido especificado correctamente.');
            return;
        }
        
        if(!validarCampoString(this.state.codCtaDepositoSeleccionada, 2)){
            alert('No ha seleccionado la Cuenta Bancaria en la que se depositaron los Cheques a anular.');
            return;
        }

        if (this.state.chequesPorCuenta.length===0){
            alert('No ha seleccionado los Cheques que desea anular.');
            return;
        }

        let nroItemsAAnularConStatus = 0;
        
        this.state.chequesPorCuenta.forEach((cheque)=>{
            if(cheque.Status==='E'){
                nroItemsAAnularConStatus+=1;
            }
        });

        if (nroItemsAAnularConStatus === 0){
            alert('No existen Cheques que hayan sido depositados para proceder a anular.');
            return;
        }
        
        let validPermiso = validarPermisoAcceso(this.state.operacion, this.props.permiso);
        if (!validPermiso.esValido){
            alert(validPermiso.msg);
            return;
        }

        let anularLoteDepositos = window.confirm(`¿Está seguro de anular el Lote de Depósitos seleccionado. Nro Cheques: ${nroItemsAAnularConStatus}?`);
        if(!anularLoteDepositos){
          return;
        }

        this.props.cambiar_VisualizacionLoading(true);
        global_axios({
            method: 'DELETE',
            url: `/depositoscheque/${planillaDepositoId}/${this.state.codCtaDepositoSeleccionada}`,
            headers: {'idregaudit': this.props.idRegAudit}
        })
        .then(()=>{
            alert('Se anuló correctamente el Lote de Depósitos seleccionado.');            
            this.props.cambiar_VisualizacionLoading(false);            
            this.cargarCuentasBancariasPorPlanillaDeposito();
            this.props.cargar_PlanillaDepositoChequeDistrib(planillaDepositoId);
            this.setState({chequesPorCuenta: [], ctaDepositoSeleccionada: '', codCtaDepositoSeleccionada: ''});
        })
        .catch(error => {
            this.props.cambiar_VisualizacionLoading(false);
            alert(error.response?error.response.data.msg:error.message);
        });
    }

    render(){        
        return(
            <ContenedorForm porc_ancho={76}>
             <HeaderForm>
                <TituloForm>Depósito Masivo de Cheques de Cobranza</TituloForm>
            </HeaderForm>
                <CuerpoForm>
                    <Row>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Planilla Depósito Cheque:</LabelForm>
                            <InputSearch tipoInput='text' nombre='planillaDepositoId' placeholder='Plan. Depósito Cheque' valor={this.state.planillaDepositoId} 
                                func_CambiarValor={this.cambiarValoresInput} func_BuscarValor={this.getPlanillaDepositobyId} func_OnFocus={()=>{this.limpiar()}}/>
                        </ContainerCol>
                        <ContainerCol className='col-sm-8'>                            
                            <Row>
                                <ContainerCol className='col-sm-3'>
                                    <LabelOperacion>{this.state.isDeposito?'Depositar':'Anular'}</LabelOperacion>
                                    <ContenedorToggle>
                                        <ToggleSwitch
                                            checked={this.state.isDeposito}
                                            onChange={() => {   this.setState({    isDeposito: !this.state.isDeposito, 
                                                                                    operacion: !this.state.isDeposito?'G':'M',
                                                                                    ctaDepositoSeleccionada: '',
                                                                                    codCtaDepositoSeleccionada: '',
                                                                                    chequesPorCuenta: []
                                                                                });

                                                                this.apiGridCuentas.deselectAll();
                                                            }}
                                            size='sm'
                                        />
                                    </ContenedorToggle>
                                </ContainerCol>                                
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-12'>
                                    <LabelForm>Distribución de Cuentas Bancarias a Depositar/Depositadas:</LabelForm>
                                    <LabelNota>{`Debe hacer doble click sobre una cuenta bancaria para seleccionar los cheques a ${this.state.isDeposito?'depositar':'anular'}.`}</LabelNota>
                                    <AgGridRender altura='100px' data={this.state.cuentasBancarias} columnas={this.state.columnsDefGridCuentas}
                                        gridOptions={this.gridCuentasOptions} onGridReady={this.onGridCuentasReady}/>
                                </ContainerCol>
                            </Row>
                        </ContainerCol>
                    </Row>
                    <Row margen_arriba={5}>
                        <ContainerCol className='col-sm-4'>
                            <LabelForm>Cuenta Bancaria Seleccionada:</LabelForm>
                            <LabelCtaSeleccionada>{this.state.ctaDepositoSeleccionada}</LabelCtaSeleccionada>                            
                        </ContainerCol>
                        <ContainerCol className='col-sm-2' isInvisible={this.state.operacion==='M'}>
                            <LabelForm>Fecha Depósito:</LabelForm>
                            <PickerFecha fechaSeleccionada={this.state.fechaDeposito}
                                func_onChange={(fecha)=>{this.setState({fechaDeposito: fecha})}}
                                disabled={!(this.props.permiteCambioFProceso==='S')}
                            />
                        </ContainerCol>
                    </Row>
                    <Row>
                        <ContainerCol className='col-sm-12'>
                            <AgGridRender altura='260px' data={this.state.chequesPorCuenta} columnas={this.state.columnsDefGridChequesPorCuenta}
                            gridOptions={this.gridChequesPorCuentaOptions} onGridReady={this.onGridChequesPorCuentaReady}/>
                        </ContainerCol>
                    </Row>
                    <Row>
                        <div className='col-sm-12'>
                            <div className='btn-group pull-right'>                                
                                <button type='button' className='btn btn-primary btn-sm' onClick={this.procesarDepositos} disabled={this.state.operacion==='M'}>
                                    <i className='fa fa-floppy-o fa-lg'/> Guardar Lote de Depósitos</button>
                                <button type='button' className='btn btn-danger btn-sm' onClick={this.anularLoteDepositos} disabled={this.state.operacion==='G'}>
                                    <i className="fa fa-ban fa-lg"></i> Anular Lote de Depósitos</button>
                                <button type='button' className='btn btn-sm' onClick={this.limpiar}><i className='fa fa-trash-o fa-lg'/> Limpiar</button>                                
                            </div>
                        </div>
                    </Row>
                </CuerpoForm>
            </ContenedorForm>
        )
    }
}

const mapStateToProps = ((state) => {
    return {    planillaDepCheque: state.bancos.planillaDepCheque,
                cuentasBancarias: state.bancos.cuentasBancarias,
                itemsPlanillaDepCheque: state.bancos.itemsPlanillaDepCheque,
                permiso: state.sesion.valoresSesionForm.Permiso,
                idRegAudit: state.sesion.valoresSesionForm.IdRegAudit,
                permiteCambioFProceso: state.sesion.valoresSesionForm.CambioFechaProceso,
                diasPermiteCambioFProceso: state.sesion.valoresSesionForm.CantidadDias
        }
});
  
const mapDispatchToProps = ((dispatch) => {  
return bindActionCreators({ generar_LogAuditoriaIngresoForm, generar_LogAuditoriaSalidaForm, cargar_PlanillaDepositoChequeDistrib,
                            cargar_CtasBancariasPorDistribPlanillaDeposito, cambiar_VisualizacionLoading,
                            cargar_DetalleChequesPlanillaDeposito }, dispatch)
});
  
export default connect(mapStateToProps, mapDispatchToProps)(FormBanco02);